var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 18v-2h-6v10h2v-4h3v-2h-3v-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 26h-4v-10h4a3.0033 3.0033 0 0 1 3 3v4a3.0033 3.0033 0 0 1 -3 3zm-2-2h2a1.0011 1.0011 0 0 0 1-1v-4a1.0011 1.0011 0 0 0 -1-1h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11 16h-5v10h2v-3h3a2.0027 2.0027 0 0 0 2-2v-3a2.0023 2.0023 0 0 0 -2-2zm-3 5v-3h3l.001 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 14v-4a.9092.9092 0 0 0 -.3-.7l-7-7a.9087.9087 0 0 0 -.7-.3h-10a2.0059 2.0059 0 0 0 -2 2v24a2 2 0 0 0 2 2h16v-2h-16v-24h8v6a2.0059 2.0059 0 0 0 2 2h6v2zm-8-4v-5.6l5.6 5.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b737102391d675989a020cbfb99bd1e1.svg";
export { ForwardRef as ReactComponent };